// extracted by mini-css-extract-plugin
module.exports = {"content":"_1e9e1146","container":"_65061b88","sticky":"_c48e98d0","cutoff":"_5ceb0bc2","shadow":"_c6949169"};